var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImageUpload',{attrs:{"isPublic":_vm.isPublic,"disabled":_vm.disabled},on:{"imageUploaded":_vm.handleImageUploaded},scopedSlots:_vm._u([{key:"default",fn:function({ isDraggingFile, isUploading, selectFile }){return [_c('div',{staticClass:"uploader",class:{
        'uploader--dragging': isDraggingFile,
        'uploader--disabled': _vm.disabled,
      },attrs:{"data-tourid":_vm.tourId},on:{"click":selectFile}},[_c('WidgetLoader',{attrs:{"show":isUploading}}),(!isUploading)?_c('em',{staticClass:"material-icons uploader__icon"},[_vm._v("insert_photo")]):_vm._e()],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }